import angular from "angular";
import user from "../user";
import core from "../../core/core.module";

angular
    .module('usersControl.userRoles', [user, core])
    .component('userRoles', {
        controller: ['User', '$timeout', 'notifier', controller],
        template: require('./user-roles.html'),
        bindings: {
            user: '<',
            roles: '<',
            modules: '<',
            userRoles: '<'
        }
    });

function controller(User, $timeout, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $timeout(function () {
            setRolesStatus();
        });
    };

    $ctrl.selectRole = function (role) {
        if ($ctrl.selectedRole == role) {
            $ctrl.selectedRole = null;
        } else {
            $ctrl.selectedRole = role;
        }
        setPermissionsStatus();
    };

    function setRolesStatus() {
        $ctrl.roles.forEach(function (role) {
            role.isSelected = false;
            for (let i = 0; i < $ctrl.userRoles.length; i++) {
                if (role.id == $ctrl.userRoles[i].id) {
                    role.isSelected = true;
                    return;
                }
            }
        });
    }

    function setPermissionsStatus() {
        $ctrl.modules.forEach(function (module) {
            module.permissions.forEach(function (permission) {
                permission.isSelected = false;
            });
        });
        if ($ctrl.selectedRole) {
            $ctrl.modules.forEach(function (module) {
                module.permissions.forEach(function (permission) {
                    let permissionExists = false;
                    for (let i = 0; i < $ctrl.selectedRole.permissions.length; i++) {
                        if (permission.id == $ctrl.selectedRole.permissions[i].id) {
                            permissionExists = true;
                            break;
                        }
                    }
                    permission.isSelected = permissionExists;
                });
            });
        }
    }

    $ctrl.toggleRole = function () {
        User
            .toggleRole($ctrl.user.id, $ctrl.selectedRole.id)
            .then(
                function () {
                    $ctrl.selectedRole.isSelected = !$ctrl.selectedRole.isSelected;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default 'usersControl.userRoles';



// WEBPACK FOOTER //
// ./resources/assets/modules/users-control/user-roles/user-roles.js